import React, { useEffect, useRef, useState } from 'react'
import { Icon } from './icon';
import { Text } from './text';
import { DropDown } from './textfield';
import './tokenfield.css'

/**
 * Token Field
 */
export const TokenField = ({ id, label, init = [], readOnly, options, onChange }) => {
  const mounted = useRef(false)
  const [value, setValue] = useState()
  const [tokens, setTokens] = useState(init)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (mounted.current) {
      if (onChange) {
        if (tokens) onChange(id, tokens)
      }
    } else {
      mounted.current = true
    }
  }, [tokens])

  function remove(index) {
    const next = tokens.slice()
    next.splice(index, 1)
    setTokens(next)
  }

  function change(event) {
    const value = event.target.value
    setValue(value)
  }

  function changeDropDown(id, value) {
    const next = tokens.concat(value)
    setTokens(next)
    setValue('xxx')
  }

  function onEnter(event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      event.stopPropagation()
      const token = event.target.value
      const next = tokens.concat(token)
      setTokens(next)
      setValue('')
    }

    if (value === '' && tokens.length > 0 && event.key === 'Backspace') {
      const next = tokens.slice(0, -1)
      setTokens(next)
    }
  }

  return (
    <div className='tokenField'>
      <label>{label}</label>
      {tokens.map((text, index) => <Token text={text} onDelete={() => remove(index)} />)}
      {options ? (
        <DropDown onChange={changeDropDown} options={options} predictive={true} verbose={false} />
      ) : (
        <input type='text' value={value} onChange={change} onKeyDown={onEnter} readOnly={readOnly} />)
      }
    </div>
  )
}

/**
 * Token
 */
const Token = ({ text, onDelete }) => {
  return (
    <div className='token'>
      <Text use='caption' tag='div'>
        {text}
      </Text>
      <Icon icon='close' clickable action={onDelete} size="small" />
    </div>
  )
}
